import { Component, Inject, OnInit } from '@angular/core';
import { ComponentDetails } from '../../../../../app/modules/manage-equipment/models/manage-equipment.model';
import { InterpretationService } from '../../../../../app/modules/interpretation/interpretation.service';
import { EquipmentRecordActionService } from '../../equipment-record-action.service';
import { ManageEquipmentService } from '../../../../../app/modules/manage-equipment/manage-equipment.service';
import { RSHMainMPInfo, UnitOfMeasurement } from '../../../../../app/modules/rope-shovel/models/rope-shovel.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-calculate-action-worn',
  templateUrl: './calculate-action-worn.component.html',
  styleUrls: ['./calculate-action-worn.component.scss']
})
export class CalculateActionWornComponent implements OnInit {
UOM:number=1;
Component:ComponentDetails;
toolId:number;
Measurement:number;
Worn:number;
IsRSH:boolean=false;
compartId:number;
MainMeasurment:RSHMainMPInfo;
  MPId: number;
  UnitOfMeasurement: UnitOfMeasurement[];
  constructor(public dialogRef: MatDialogRef<CalculateActionWornComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _manageEquipmentService: ManageEquipmentService) { }

  ngOnInit() {
    this.Component = this._data.Component;
    this.IsRSH = this._data.IsRSH;
    this.compartId = this._data.compartId;
    if(this.compartId>0){
      this.GetMainMeasurementPoitnRecord();
    }
    this.getUnitOfMeasurement();
  }
  onNoClick(){
    this.dialogRef.close(null);
  }

GetMainMeasurementPoitnRecord(){
  this._manageEquipmentService.GetMainCompartMeasurmentPointDetails(this.compartId).subscribe(res=>{
    this.MainMeasurment = res;
    this.MPId=this.MainMeasurment.CompartMPId;
    this.toolId = this.MainMeasurment.possibletools[0].ToolId;
  })
}

  getUnitOfMeasurement() {
    this._manageEquipmentService.getUnitOfMeasurement(this.compartId).subscribe(res => {
      if (res) {
        this.UnitOfMeasurement = res;
        if (this.UnitOfMeasurement.length > 0)
          this.UOM = this.UnitOfMeasurement[0].Id;
      }
    })
  }

  CalculateWorn(){
    //console.log("resu", this.Measurement, this.toolId, this.UOM)
    this.Component.ActionReading=this.Measurement;
    this.Component.ActionToolId=this.toolId;
    this.Component.UOM=this.UOM;
    console.log(this.toolId);
    console.log(this.Component.ActionToolId);
    if(this.IsRSH==false){
      this._manageEquipmentService.CalculateWornPercentage(this.UOM,this.toolId, 1,this.Component.Id, this.Measurement).subscribe(res=>{
      //console.log("result", res);
      console.log(this.toolId);
      console.log(this.Component.ActionToolId);
      this.Worn=res.body.m_Item2;
      this.Component.ActionWorn=this.Worn;
    })
  }
  if(this.IsRSH==true){
    this._manageEquipmentService.CalculateMainRSHCompartMeasurementWornPercentage(this.MPId,this.toolId,this.UOM,this.Measurement).subscribe(res=>{
    //console.log("result", res);
    this.Worn=res;
    this.Component.ActionWorn=this.Worn;
  })
}
}

  save(){
    this.dialogRef.close(this.Component);
  }
}

